class LocalStorageKeys {
  static adminToken = "ghkjhfdkivhgrowihgiot-ioyrfiyityufygjgh-jhghhghj";
}
export default LocalStorageKeys;
